import React, { Component } from 'react';
import imageText from './img/text01.png';
import imageButtonNormal from './img/btn04.png';
import imageButtonRandom from './img/btn05.png';
import './view.css';

class ViewSelect extends Component {
    render() {
        return (
            <div className="container centering">
                <div className="description">
                    <div>
                        <img src={imageText}></img>
                    </div>
                </div>
                <div className="buttons">
                    <div onClick={() => this.props.onClickSelect('normal')}>
                        <img src={imageButtonNormal} id="normal"></img>
                    </div>
                    <div onClick={() => this.props.onClickSelect('random')}>
                        <img src={imageButtonRandom} id="random"></img>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewSelect;
